export default {
  COMMENTS: 'comments',
  PENDING_SIGNATURES: 'pendingSignatures',
  PENDING_NOTES: 'pendingNotes',
  PENDING_ACTIVITIES: 'pendingActivities',
  MISSED_APPOINTMENT: 'missedAppointment',
  TARGET_MASTERY: 'targetMastery',
  PENDING_SESSION: 'pendingSession',
  PENDING_REPORT_REVIEW: 'pendingReportReview',
  PROGRAM_MODIFICATION: 'programModification',

  SESSION_FINISHED: 'sessionFinished',
  SESSION_FILES_ATTACHED: 'sessionFilesAttached',
  TARGET_REOPENED: 'targetReopened',
  VIDEO_SESSION_INVITATION: 'videoSessionInvitation',
  FILE_UPLOAD_FAILED: 'fileUploadFailed',
  SESSION_REMINDER: 'sessionReminder',
  SESSION_ACTIVITY_CHANGE_REQUEST_REJECTED: 'sessionActivityChangeRequestRejected',
  CANCELLED_APPOINTMENT: 'cancelledAppointment',
  RESTORED_APPOINTMENT: 'restoredAppointment',
};

export const NOTIFICATION_FILTERS = {
  ACTION_NOTIFICATIONS: 'ACTION_NOTIFICATIONS',
  ACTIVE_ACTION: 'ACTIVE_ACTION',
  COMPLETED_ACTION: 'COMPLETED_ACTION',
  INFO_NOTIFICATIONS: 'INFO_NOTIFICATIONS',
};

export const CLIENTS_NOTIFICATIONS_TYPES = {
  CLIENT_ADDED: 'clientAdded',
  CLIENT_UPDATED: 'clientUpdated',
  CLIENT_REMOVED: 'clientRemoved',
};

export const INTEGRATION_REFERENCES_NOTIFICATIONS_TYPES = {
  REFERENCES_UPDATED: 'referencesUpdated',
};
